import { ref, watch, toValue, type MaybeRefOrGetter } from "vue";
import { useApiClient } from "@/api/client";
import MasterPriceListImportDO = Modules.BookingExperts.Data.MasterPriceList.MasterPriceListImportDO;

export const usePriceListImport = (
	priceListId: MaybeRefOrGetter<number | undefined>,
	importId: MaybeRefOrGetter<number | undefined>,
	enabled: MaybeRefOrGetter<boolean> = true
) => {
	const importItem = ref<MasterPriceListImportDO>();
	const isLoading = ref(false);

	let requestId = 0;

	const fetchImport = async () => {
		const listId = toValue(priceListId);
		const id = toValue(importId);

		if (!listId || !id || !toValue(enabled)) {
			return;
		}

		const current = ++requestId;
		isLoading.value = true;

		const response = await useApiClient("bookingExperts").getPriceListImport(
			listId,
			id
		);

		// A newer fetch started while this one was in flight; drop the result.
		if (current !== requestId) {
			return;
		}

		if (response.isOk()) {
			importItem.value = response.value;
		}
		isLoading.value = false;
	};

	watch(
		[
			() => toValue(priceListId),
			() => toValue(importId),
			() => toValue(enabled),
		],
		fetchImport,
		{ immediate: true }
	);

	return { importItem, isLoading, refresh: fetchImport };
};
